import React, { useEffect, useRef } from "react";
import "./TranslateWidget.css";

/**
 * TranslateWidget - Only used on public Customer-View pages.
 * Dashboard users set their language in Settings > Preferences instead.
 */
const TranslateWidget = ({ className = "" }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    container.innerHTML = "";

    const initWidget = () => {
      if (!window.google?.translate?.TranslateElement) return;
      try {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages:
              "de,es,fr,ar,en,it,ur,zh-CN,ja,ru,ms,th,ko,hi,fa",
            layout: 0,
          },
          container
        );
      } catch (e) {
        // ignore
      }
    };

    if (window.google?.translate?.TranslateElement) {
      initWidget();
      return;
    }

    // Load the script if not already present (Customer-View pages don't go through index.js)
    if (!document.querySelector('script[src*="translate.google.com/translate_a/element.js"]')) {
      const script = document.createElement("script");
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      window.googleTranslateElementInit = () => {
        setTimeout(initWidget, 100);
      };
      document.body.appendChild(script);
    }

    return () => {
      container.innerHTML = "";
    };
  }, []);

  return (
    <div className={`translate-widget ${className}`.trim()}>
      <div ref={containerRef} />
    </div>
  );
};

TranslateWidget.displayName = "TranslateWidget";

export default TranslateWidget;
